declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
  }
}

let scriptLoaded = false
const initializedPixels = new Set<string>()

export function initMetaPixel(pixelId: string) {
  if (typeof window === 'undefined') return

  // Load the fbq script only once
  if (!scriptLoaded) {
    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.head.appendChild(script)
    }

    scriptLoaded = true
  }

  // Init each pixel only once
  if (!initializedPixels.has(pixelId)) {
    window.fbq('init', pixelId)

    // Add noscript fallback
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)

    initializedPixels.add(pixelId)
  }
}

export function trackPixelEvent(event: string, data?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', event, data)
  }
}
